<div class="or-d-flex or-px-16-px overflow-y-auto or-mb-4-px">
  <div
    (click)="goToMyGames()"
    class="border-shade border-radius-4 or-px-12-px or-pt-12-px or-pb-8-px or-mr-8-px or-w-112-px or-min-w-112-px or-bg-white">
    <or-icon name="games" size="m" />
    <div class="or-text-md or-my-4-px">Twoje gierki</div>
  </div>

  @if (rankFF()) {
    <div
      (click)="goToRank()"
      class="border-shade border-radius-4 or-px-12-px or-pt-12-px or-pb-8-px or-mr-8-px or-w-112-px or-min-w-112-px or-bg-white">
      <or-icon name="ranking" size="m" />
      <div class="or-text-md or-my-4-px">Rankingi</div>
    </div>
  }

  <div
    (click)="goToAlerts()"
    class="border-shade border-radius-4 or-px-12-px or-pt-12-px or-pb-8-px or-w-112-px or-min-w-112-px or-bg-white">
    <or-icon name="alerts" size="m" />
    <div class="or-text-md or-my-4-px">Alerty o gierkach</div>
  </div>
</div>
